<template>
  <a-dialog :value="value" persist @input="$emit('input', $event)">
    <span
      slot="header"
      v-t="'Security.UserAdministration.PasswordResetSendEmail'"
      class="headline"
    />
    <div
      slot="body"
      v-t="'Security.UserAdministration.PasswordResetSendEmailDescription'"
      class="pre"
    />
    <div slot="footer">
      <button
        v-t="'Security.UserAdministration.PasswordResetAbort'"
        class="btn btn-pf-secondary"
        @click="$emit('input', false)"
      />
      <button
        v-t="'Security.UserAdministration.PasswordResetSendEmail'"
        class="btn btn-pf-primary ml-2"
        @click="sendEmail()"
      />
    </div>
  </a-dialog>
</template>

<script>
import Dialog from "+/components/dialog/Dialog";
export default {
  components: {
    "a-dialog": Dialog
  },
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    sendEmail() {
      this.$rest.security
        .sendPasswordResetMail(this.user.id)
        .then(this.sendingEmailSuccess)
        .catch(this.sendingEmailException);
    },
    sendingEmailSuccess() {
      const successMessage = this.$t(
        "Security.UserAdministration.PasswordResetSendEmailSuccessFeedback"
      );
      this.$feedback(successMessage, {
        type: "success"
      });
    },
    sendingEmailException() {
      const error = this.$t(
        "Security.UserAdministration.PasswordResetSendEmailException"
      );
      this.$feedback(error, { type: "error" });
    }
  }
};
</script>
